<template>
  <v-container fluid>
    <div>
      <div>
        <div class="grid" v-if="patients.length > 0">
          <div
            v-for="patient in patients"
            v-bind:key="patient.id"
            @click="$store.commit('updatePatient', patient)"
          >
            <Person
              :class="{
                'archived-person': patient.isArchived || patient.isDeceased
              }"
              @edit-person="$modal.show('menu-modal' + patient.id)"
              @select-person="selectPatient(patient)"
              :person="patient"
              patient
            />
            <modal
              class="menu"
              :name="'menu-modal' + patient.id"
              width="100%"
              height="auto"
            >
              <ListItem
                border="1px solid #31b9be"
                @click.native="
                  redirect(`/dashboard/parent/add?patientId=${patient.id}`)
                "
                >{{ $t("dash.patient.add-parent") }}</ListItem
              >
              <ListItem
                v-if="!hl7Enabled"
                border="1px solid #31b9be"
                @click.native="
                  redirect(`/dashboard/nurse/${$store.getters.nurse.id}/patient/create?patientId=${patient.id}`)
                "
                >{{ patient.firstName }} {{ $t("dash.patient.edit") }}</ListItem
              >
              <ListItem
                border="1px solid #31b9be"
                v-if="!hl7Enabled"
                @click.native="toggleArchivePatient(patient)"
                >{{ patient.firstName }}
                {{ $t("dash.patient.archive.title") }}</ListItem
              >
              <ListItem
                v-if="!hl7Enabled"
                last="true"
                border="1px solid #31b9be"
                class="pink--text"
                @click.native="patientDeceased(patient)"
                >{{ patient.firstName }}
                {{ $t("dash.patient.deceased") }}</ListItem
              >
            </modal>
          </div>
        </div>
        <div v-if="(!patients || patients.length === 0) && !loading">
          <p>{{ $t("dash.patient.not-found") }}</p>
        </div>
        <h3
          @click="collapseContent('archive')"
          v-if="archivedPatients.length > 0"
        >
          {{ $t("dash.patient.history") }}
          <img
            :src="
              require(`@/assets/icons/${
                archiveIsCollapsed ? 'arrow-up-pink.svg' : 'arrow-down-pink.svg'
              }`)
            "
            class="icon"
          />
        </h3>
        <div
          id="archive-content"
          class="grid content-closed"
          v-if="archivedPatients.length > 0"
        >
          <div
            v-for="patient in archivedPatients"
            v-bind:key="patient.id"
            class=""
          >
            <Person
              :class="{
                'archived-person': patient.isArchived || patient.isDeceased
              }"
              @edit-person="$modal.show('menu-modal' + patient.id)"
              @select-person="selectPatient(patient)"
              :person="patient"
              patient
            />
            <modal
              class="menu"
              :name="'menu-modal' + patient.id"
              width="100%"
              height="auto"
            >
              <ListItem
                v-if="!patient.isArchived && !patient.isDeceased"
                border="1px solid #31b9be"
                @click.native="
                  redirect(`/dashboard/nurse/create?patientId=${patient.id}`)
                "
                >{{ patient.firstName }} {{ $t("dash.patient.edit") }}</ListItem
              >
              <ListItem
                last="true"
                v-if="!hl7Enabled"
                border="1px solid #31b9be"
                @click.native="toggleArchivePatient(patient)"
                >{{ patient.firstName }}
                {{ $t("dash.patient.resubmit") }}</ListItem
              >
            </modal>
          </div>
        </div>
      </div>
      <div class="fab-container no-tab">
        <Button
          v-if="($store.getters.user.role === 'a' || $store.getters.user.role === 'n') && (!this.$store.getters.user.hospital || !this.$store.getters.user.hospital.epdSettings || !this.$store.getters.user.hospital.epdSettings.epdEnabled)"
          class="fab"
          title
          color="#fff"
          bgcolor="#00A9B3"
          width="42px"
          height="42"
          margin="0"
          padding="0"
          icon="plus-white"
          @click.native="redirect(`/dashboard/nurse/${$store.getters.nurse.id}/patient/create`)"

        />
      </div>
      <modals-container class="comment" @add-reason="reasonAdded" />
    </div>
  </v-container>
</template>

<script>
import {neoparentPatients, neoparentDictionaryEntries, neoparentUsers, neoparentPosts} from "@/api";
import TextAreaField from "@/page_elements/TextAreaField";
import Button from "@/page_elements/Button";

export default {
  name: "neoparent-patients",
  components: {
    Button,
    TextAreaField,
  },
  data() {
    return {
      loading: true,
      patients: [],
      deceasedDictionaryEntry: null,
      hl7Enabled: false,
      archivedPatients: [],
      archiveIsCollapsed: false
    };
  },
  mounted() {
    this.getPatients();
    this.getDeceasedDictionaryEntry();
    this.hl7Enabled = this.$store.getters.user.hospital.hl7Enabled;
  },
  methods: {
    getPatients() {
      neoparentPatients
        .getAllPatientsForHospital(this.$store.getters.user.hospital.id)
        .then(result => {
          this.patients = result.data.patients
            .filter(p => !p.isArchived && !p.isDeceased)
          this.archivedPatients = result.data.patients
            .filter(p => p.isArchived || p.isDeceased)
            .sort((a, b) => a.firstName.localeCompare(b.firstName));
          this.loading = false;
        })
        .catch(err => {
          this.consoleLog(err);
        });
    },
    getDeceasedDictionaryEntry() {
      neoparentDictionaryEntries
        .getDeceasedDictionaryEntry()
        .then(result => {
          this.consoleLog(result);
          this.deceasedDictionaryEntry = result.data.deceasedDictionaryEntry;
        })
        .catch(err => {
          this.consoleLog(err);
        });
    },
    collapseContent(tag) {
      document
        .getElementById(`${tag}-content`)
        .classList.toggle("content-closed");
      this.archiveIsCollapsed = !this.archiveIsCollapsed;
    },
    deletePatient(id) {
      // if (confirm(this.$t("dash.patient.confirm"))) {
      //   try {
      //     this.$modal.hide("menu-modal" + patientId);
      //     await axios.post(
      //       `${this.$backendRoot}/patients/${patientId}/delete`,
      //       {
      //         token: this.$session.get("admin-token")
      //       }
      //     );
      //     this.fetchPatients();
      //   } catch (e) {
      //     this.consoleLog(e);
      //   }
      // }
    },
    patientDeceased(patient) {
      const that = this

      if (confirm(this.$t("dash.patient.confirm-deceased"))) {
        this.$modal.hide("menu-modal" + patient.id);
        neoparentPatients
          .setPatientDeceased(patient.id)
          .then(result => {
            this.consoleLog(result);

            const patient = this.patients.find(x => x.id === result.data.patient.id)
            const patientIndex = this.patients.findIndex(x => x.id === result.data.patient.id)
            that.patients.splice(patientIndex, 1)
            patient.isArchived = true
            patient.isDeceased = true
            that.archivedPatients.push(patient)

            // Prepare post for parents
            const post = {
              title: this.$store.getters.user.hospital.hospitalDefaultMessages.onDeceased.title,
              content: this.$store.getters.user.hospital.hospitalDefaultMessages.onDeceased.message?.replace("<p class=\\\"clearfix\\\">","").replace("</p>",""),
              access: "priv",
            }

            neoparentPosts.addPost(result.data.patient.id, post)
          })
          .catch(err => {
            this.consoleLog(err);
          });
      }
    },
    selectPatient(patient) {
      neoparentUsers.selectPatient(patient.id)
        .then(() => {
          this.$store.commit("updatePatient", patient);
          this.redirect(
            `/dashboard/nurse/${this.$store.getters.nurse.id}/patient/${patient.id}`
          );
        })

    },
    toggleArchivePatient(patient) {
      this.$modal.hide("menu-modal" + patient.id);
      if (
        patient.isArchived &&
        confirm(this.$t("dash.patient.confirm-activate"))
      ) {
        // Re-activate patient
        neoparentPatients
          .toggleArchivePatient(patient.id)
          .then(result => {

            const post = {
              title: this.$store.getters.user.hospital.hospitalDefaultMessages.onReSubmit.title,
              content: this.$store.getters.user.hospital.hospitalDefaultMessages.onReSubmit.message?.replace("<p class=\\\"clearfix\\\">","").replace("</p>",""),
              access: "priv",
            }
            neoparentPosts.removeDeceased(result.data.patient.id);
            neoparentPosts.addPost(result.data.patient.id, post)
            this.getPatients();
          })
          .catch(err => {
            this.consoleLog(err);
          });
      } else {
        this.$modal.show(
          {
            template: `
            <div>
              <Button
                class="close"
                @click.native="$modal.hide($parent.name)"
                margin="10px"
                color="#31b9be"
                bgcolor="transparent"
                width="30px"
                padding="0"
                icon="close-blue"
              ></Button>
              <h3>${this.$t("dash.patient.archive.reason")}</h3>
              <TextAreaField rows="3" v-model="reason" labelTitle placeholder="${this.$t(
                "dash.patient.archive.reason"
              )}"></TextAreaField>
              <Button
                title="${this.$t("dash.patient.archive.action-dismiss")}"
                shadow="true"
                @click.native="$modal.hide($parent.name); $emit('add-reason', {reason, patientId});"
                margin="1rem 0"
              ></Button>
            </div>
          `,
            components: {
              TextAreaField,
              Button
            },
            props: {
              patientId: {}
            },
            data: function() {
              return {
                reason: null
              };
            }
          },
          {
            patientId: patient.id
          },
          {
            height: "auto",
            width: "90%",
            class: "comment"
          }
        );
      }
    },
    reasonAdded(event) {
      this.consoleLog(event);
      neoparentPatients
        .toggleArchivePatient(event.patientId, event.reason || null)
        .then(result => {
          this.consoleLog(result);
          this.getPatients();
          // Prepare archive post for parents
          // Prepare post for parents
          const post = {
            title: this.$store.getters.user.hospital.hospitalDefaultMessages.onDismissal.title,
            content: this.$store.getters.user.hospital.hospitalDefaultMessages.onDismissal.message?.replace("<p class=\\\"clearfix\\\">","").replace("</p>",""),
            access: "priv",
          }

          neoparentPosts.addPost(result.data.patient.id, post)
        })
        .catch(err => {
          this.consoleLog(err);
        });
    }
  }
};
</script>

<style scoped lang="scss">
.grid {
  grid-template-columns: repeat(1, 1fr);
  grid-gap: 48px;
  display: grid;
  justify-content: center;
  width: 90%;
  margin: 48px auto;

  @media (min-width: 500px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: 700px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (min-width: 900px) {
    grid-template-columns: repeat(4, 1fr);
  }
}

.grid a {
  margin: 25px;
  width: 100px;
}

.patient-card {
  border: black solid 1px;
  border-color: #e57378;
  margin: 0px auto;
  width: 150px;
}

.icon {
  width: 42px;
  vertical-align: middle;
}
</style>
